import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Sheet } from '../Sheet';
import type { Case } from '../../../types/admin';
import { relativeUpcoming } from '../../../utils/adminDates';
interface CasePickerDialogProps {
  open: boolean;
  title: string;
  cases: Case[];
  onPick: (item: Case) => void;
  onClose: () => void;
}

/** "Hvilken sag?" — før timer eller materiale registreres fra I dag. */
export function CasePickerDialog({
  open,
  title,
  cases,
  onPick,
  onClose
}: CasePickerDialogProps) {
  return <Sheet open={open} title={title} onClose={onClose} data-id="element-680" data-mp="18ahokfw2lcwr">
      <p className="text-sm text-ink-muted" data-id="element-681" data-mp="147te63rpjxxo">Vælg sagen</p>
      {cases.length === 0 ? <p className="mt-3 text-[15px] text-ink-soft" data-id="element-682" data-mp="149o09leptw3c">Der er ingen sager, der er planlagt eller i gang.</p> : <ul className="mt-2 divide-y divide-line" data-id="element-683" data-mp="3oxskk8t3tyy6">
          {cases.map(item => <li key={item.id} data-id="element-684" data-mp="3jyz4q9qchvuu">
              <button type="button" onClick={() => onPick(item)} className="flex min-h-[3.5rem] w-full items-center gap-3 py-2.5 text-left" data-id="element-685" data-mp="3jypohdv3r32c">
                <span className="min-w-0 flex-1" data-id="element-686" data-mp="t8675emcoqah">
                  <span className="block truncate text-[15px] font-medium text-ink" data-id="element-687" data-mp="t5k3hq2kyuxj">{item.title}</span>
                  <span className="block truncate text-sm text-ink-muted" data-id="element-688" data-mp="fahmo7w73l5y">
                    {item.customerName} · {relativeUpcoming(item.plannedDate)}
                  </span>
                </span>
                <ChevronRightIcon className="h-4 w-4 shrink-0 text-ink-faint" aria-hidden="true" data-id="element-689" data-mp="5giofjz8slja" />
              </button>
            </li>)}
        </ul>}
    </Sheet>;
}